import { AnyAction } from 'redux';
import { DraftConfiguration, SpecialFontTask, StoreSpecialFont } from '@/types';
import { isDraftTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { fetchSpecialFontTask } from '@/model/font/fetchSpecialFontTask';
import { getDraftDispatch } from '@/redux/draft/draftDispatch';
import { getConfiguration } from '@/redux/draft/getters/getConfiguration';
import { Thunk } from '@/redux/types';
import { convertTextToSpecialTextAction } from '@/components/draft/draftState/actions/convertTextToSpecialTextAction';

export const convertTextToSpecialTextConfigurationAction =
  (configuration: DraftConfiguration, font: StoreSpecialFont): Thunk<Promise<void>, AnyAction> =>
  async (dispatch, getState) => {
    if (isDraftTextConfiguration(configuration)) {
      const {
        text: {
          content,
          style: { textAlign },
        },
      } = configuration;

      let task: SpecialFontTask;
      try {
        task = await dispatch(fetchSpecialFontTask(font.id, textAlign, content));
      } catch (error) {
        /* ignore failed fetchSpecialFontTask */
        return;
      }

      // it is possible for the user to remove the configuration before the font is loaded
      const state = getState();
      configuration = getConfiguration(state, configuration.cid);
      if (isDraftTextConfiguration(configuration)) {
        getDraftDispatch(state)(convertTextToSpecialTextAction(configuration, font, task));
      }
    }
  };
